const PATHS = {
    GET_CITIES_LIST: 'api/lists/cities?keyword={keyword}&country_id={countryId}&site={domain}&_nopaging={noPaging}&client={client}',
    GET_CITY: 'api/lists/cities?ids={ids}&site={domain}&longitude={longitude}&latitude={latitude}',
    GET_HOME_SEARCH: 'api/search/?_home=1&city_id={city}&keyword={keyword}&site={domain}&latitude={lat}&longitude={lng}',
    GET_SEARCH_V2: 'api/v2/search/?site={domain}&type={searchType}&keyword={keyword}&city_id={city}&latitude={lat}&longitude={lng}&specialty_id={specialty_id}&client_slug={client_slug}&msd={msd}',
    GET_CITY_BY_IP: 'api/geobyip?site={domain}&latitude={lat}&longitude={lng}&_nopaging={noPaging}&client={client}',
    GET_DOCTOR_DETAIL: 'api/doctors/{id}?site={site}',
    GET_HOSPITAL_DETAIL: 'api/hospital/branch/{id}?site={site}',
    GET_SERVICE_DETAIL: 'api/hospital/service/{id}?site={site}',
    GET_SEARCH_SPECIALTY: 'api/v2/specialties/?site={domain}&type={searchType}&keyword={keyword}&city_id={city}&latitude={lat}&longitude={lng}&msd={msd}',
    GET_SEARCH_POPULAR_KEY: 'api/search/keywords?site={domain}&sort_by={sort_by}&sort_order={sort_order}&type={searchType}',
};

export { PATHS as P };
